import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateAdminAccess } from '../utils/security';

function AdminRoute({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!validateAdminAccess()) {
      navigate('/iffa-admin-login');
    }
  }, [navigate]);

  if (!validateAdminAccess()) {
    return <div>Redirecting to login...</div>;
  }

  return children;
}

export default AdminRoute;